/**
 * ObjectMarkdownField React component
 * 
 * @author    Jens Gruschel
 * @copyright © 2019 contexagon GmbH
 */


// React
import React from 'react';
import PropTypes from 'prop-types';

// application components
import MarkdownEditor from "../base/MarkdownEditor";


/**
 * ObjectMarkdownField is an editing component for markdown fields of objects
 *
 * @author Jens Gruschel
 */
export class ObjectMarkdownField extends React.Component {

    handleChange(event) {
        const value = event.target.value === "" ? undefined : event.target.value;
        this.props.onObjectValueChange(this.props.fieldDef.id, value);
    };

    render() {

        const { fieldDef } = this.props;

        return <MarkdownEditor
            id={fieldDef.id}
            label={fieldDef.name}
            readOnly={this.props.readOnly}
            value={this.props.value != null ? this.props.value : ""}
            onChange={event => this.handleChange(event)}
        />;
    }
}

ObjectMarkdownField.propTypes = {
    onObjectValueChange: PropTypes.func.isRequired,
    fieldDef: PropTypes.object.isRequired,
    objectId: PropTypes.string,
    readOnly: PropTypes.bool,
    value: PropTypes.any
};

export default ObjectMarkdownField;